// Hooks (@tanstack/react-query) imports
import { useMutation } from "@tanstack/react-query";

// Configs imports
import api from "../../app/api";

// Custom types imports
import { ApiErrorResponse } from "apisauce";
import { Person } from "./types";

interface paramsType {
  email: string;
  notificationID: string | number;
}

export function usePersonByEmailMutation(
  onSuccessMutation?: (data: any, variables: paramsType) => void,
  onErrorMutation?: (err: ApiErrorResponse<any>, variables: paramsType) => void
) {
  async function personByEmail(params: paramsType): Promise<Person> {
    const response = await api.get<Person>(
      `admin/persons/byemail/${params.email}`
    );

    if (!response.ok || !response.data) {
      throw response;
    }

    return response.data;
  }

  return useMutation({
    mutationFn: personByEmail,
    onSuccess: onSuccessMutation,
    onError: onErrorMutation,
  });
}
